/* tslint:disable */
/* eslint-disable */

/**
 * Base SDK Error class
 */
export class SDKError extends Error {
    public statusCode?: number;
    public errorCode?: string;
    public details?: any;

    constructor(message: string, statusCode?: number, details?: any) {
        super(message);
        this.name = 'SDKError';
        this.statusCode = statusCode;
        this.details = details;

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}

/**
 * Authentication Error (401, 403)
 */
export class AuthenticationError extends SDKError {
    constructor(message: string, statusCode?: number, details?: any) {
        super(message, statusCode, details);
        this.name = 'AuthenticationError';
        this.errorCode = 'AUTHENTICATION_ERROR';
    }
}

/**
 * Validation Error (400)
 */
export class ValidationError extends SDKError {
    constructor(message: string, statusCode?: number, details?: any) {
        super(message, statusCode, details);
        this.name = 'ValidationError';
        this.errorCode = 'VALIDATION_ERROR';
    }
}

/**
 * Not Found Error (404)
 */
export class NotFoundError extends SDKError {
    constructor(message: string, statusCode?: number, details?: any) {
        super(message, statusCode, details);
        this.name = 'NotFoundError';
        this.errorCode = 'NOT_FOUND';
    }
}

/**
 * Conflict Error (409)
 */
export class ConflictError extends SDKError {
    constructor(message: string, statusCode?: number, details?: any) {
        super(message, statusCode, details);
        this.name = 'ConflictError';
        this.errorCode = 'CONFLICT';
    }
}

/**
 * Server Error (500+)
 */
export class ServerError extends SDKError {
    constructor(message: string, statusCode?: number, details?: any) {
        super(message, statusCode, details);
        this.name = 'ServerError';
        this.errorCode = 'SERVER_ERROR';
    }
}

/**
 * Rate Limit Error (429)
 */
export class RateLimitError extends SDKError {
    constructor(message: string, statusCode?: number, details?: any) {
        super(message, statusCode, details);
        this.name = 'RateLimitError';
        this.errorCode = 'RATE_LIMIT_EXCEEDED';
    }
}

/**
 * Network Error (no response from server)
 */
export class NetworkError extends SDKError {
    constructor(message: string, details?: any) {
        super(message, undefined, details);
        this.name = 'NetworkError';
        this.errorCode = 'NETWORK_ERROR';
    }
}
